import { css, cx } from "@emotion/css";
import type { IconSize } from "@octopusdeploy/design-system-icons";
import type { AvatarSize } from "../Avatar";

type NumericIconSize = Exclude<IconSize, "font-size">;

const iconSizeMap = {
    small: 16,
    medium: 24,
    large: 36,
} as const;

function createIconStyles(size: number): string {
    return css({
        height: `${size}px`,
        width: `${size}px`,
    });
}

const iconStylesMap = {
    16: createIconStyles(16),
    20: createIconStyles(20),
    24: createIconStyles(24),
    28: createIconStyles(28),
    36: createIconStyles(36),
} as const;

export function getIconSize(size: AvatarSize): NumericIconSize {
    return iconSizeMap[size];
}

export function getIconStyles(size: NumericIconSize): string {
    const iconBaseStyles = css({
        display: "block",
    });

    return cx(iconBaseStyles, iconStylesMap[size]);
}
